import { useMemo } from 'react';

function useSelectionLimit<T>(values: T[], limit?: number): boolean {
  return useMemo(() => {
    return !!limit && values.length >= limit;
  }, [values, limit]);
}

export default useSelectionLimit;
